import { useState, useEffect } from 'react';
import './VersionInfo.css';

const VersionInfo = () => {
  const [dbVersion, setDbVersion] = useState(null);

  const appVersion = process.env.REACT_APP_VERSION || 'dev';
  const buildInfo = process.env.REACT_APP_BUILD_INFO || '';

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await fetch('/api/version');
        if (response.ok) {
          const data = await response.json();
          setDbVersion(data.dbMigrationCount);
        }
      } catch (error) {
        // Silently fail - version info is not critical
        console.debug('Could not fetch version info:', error);
      }
    };

    fetchVersion();
  }, []);

  return (
    <div className="version-info">
      <span className="version-app">
        v{appVersion}
        {buildInfo && <span className="version-build"> ({buildInfo})</span>}
      </span>
      {dbVersion !== null && (
        <span className="version-db"> | DB: v{dbVersion}</span>
      )}
    </div>
  );
};

export default VersionInfo;
